//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import '@insights/components/rights-requests/RightsInsightsStatBubbles';
import '@insights/components/rights-requests/RightsInsightsDateFilter';
import rightsManagementPageTemplate from '@legacy-components/rights-management/rights-management-page.html';

(function () {
  const curalate = angular.module('curalate');

  curalate.directive('rightsManagementPage', [
    '$modal',
    'DateTimeService',
    'RightsManagementService',
    'SessionVarsService',
    'StringUtils',
    'TrackingService',
    'UniversalImageActionsHelpers',
    'UniversalImageActionsService',
    'UniversalImageActionsView',
    function (
      $modal,
      DateTimeService,
      RightsManagementService,
      SessionVarsService,
      StringUtils,
      TrackingService,
      UniversalImageActionsHelpers,
      UniversalImageActionsService,
      UniversalImageActionsView,
    ) {
      return {
        scope: {},
        restrict: 'E',
        template: rightsManagementPageTemplate,
        link(scope) {
          const isRightsManagementPageConfigEnabled =
            SessionVarsService.isFeatureEnabled(
              FeatureNames.RightsManagementPage,
            );

          scope.model = {
            outstandingAsyncAction: null,
            totalRightsRequests: 0,
            items: [],
            currentItems: [],
          };

          scope.model.requestsList = {
            defaultView: 'list',
            refreshGallery(params) {
              const queryParams = {
                sort: params.sort,
                sortOrder: params.direction,
                offset: params.offset,
                limit: params.limit,
              };

              if (params.filter !== 'All') {
                queryParams.status = params.filter;
              }

              scope.model.outstandingAsyncAction = 'getRequests';
              return RightsManagementService.getRightsRequestsAsync(queryParams)
                .then((response) => {
                  scope.model.requestsList.outerContext.hasAnyRequests =
                    response.hasAny;
                  scope.model.requestsList.outerContext.sort = queryParams.sort;

                  _(response.items).each((item) => {
                    item.formattedRelativeTime = moment(
                      item.originalMediaMetadata.postedTime,
                    ).from(DateTimeService.userNow());
                    item.formattedRequestedRelativeTime = moment(
                      item.rightsRequest.createdTime,
                    ).from(DateTimeService.userNow());
                    item.formattedLastUpdatedRelativeTime = moment(
                      item.rightsRequest.lastUpdatedTime,
                    ).from(DateTimeService.userNow());
                    item.parsedUniversalItemId =
                      UniversalImageActionsHelpers.parseUniversalItemId(
                        item.universalItemId,
                      );
                  });

                  return {
                    items: response.items,
                    totalCount: response.totalCount,
                  };
                })
                .finally(() => {
                  scope.model.outstandingAsyncAction = null;
                });
            },
          };

          scope.model.requestsList.outerContext = {
            hasAnyRequests: false,
            itemClicked(item) {
              if (!item.universalItemId) {
                return;
              }

              const uid = UniversalImageActionsHelpers.parseUniversalItemId(
                item.universalItemId,
              );
              UniversalImageActionsService.launch(
                UniversalImageActionsView.RightsRequest.name,
                {
                  itemId: uid.itemId,
                  itemType: uid.itemType,
                  page: 'rights-management',
                },
              );
            },
            configurationButtonClicked() {
              TrackingService.recordEvent(
                TrackingService.CATEGORY_RIGHTS_CONFIGURATION,
                `${TrackingService.ACTION_MODAL}.ConfigureModal`,
              );
              $modal.open({
                backdrop: 'static',
                template:
                  '<rights-configuration-modal close="$close(result)"></rights-configuration-modal>',
                windowClass: 'pure-bs3 modal-small',
              });
            },
            isConfigurationButtonEnabled: isRightsManagementPageConfigEnabled,
            handleCSVDownload() {
              return function (promise) {
                scope.model.downloading = true;
                promise.finally(() => {
                  scope.model.downloading = false;
                });
              };
            },
            getRightsExportUrl() {
              return RightsManagementService.getRightsExportUrl();
            },
            generateFilename() {
              const attributes = {
                base: 'rights-management-export',
                extension: 'csv',
              };

              return StringUtils.generateFileName(attributes);
            },
          };
        },
      };
    },
  ]);
})();
